import getStyles from './getStyles';
/**
 * Get the value of a computed style property for the specified element.
 * @param element The element for which to get the style.
 * @param property A CSS property
 */

export default function getStyle(element, propertyName) {
  // Sanitize property name to CSS notation (hyphen separated words e.g. font-size)
  var sanitizedPropertyName = propertyName.replace(/([A-Z])/g, '-$1').toLowerCase();
  var styles = getStyles(element);
  return styles != null ? styles.getPropertyValue(sanitizedPropertyName) : null;
}
//# sourceMappingURL=getStyle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/getStyle.js
// module id = 86
// module chunks = 0 1